export default "__VITE_ASSET__udkUh22f__"